import {SET_FETCHING_GROUP_TIMELINE, GET_GROUP_TIMELINE_SUCCESS} from './actionTypes'
import API from 'config/API'

const getGroupTimelineSuccess = (timeline) => ({
  type: GET_GROUP_TIMELINE_SUCCESS,
  payload: {timeline},
})

const setFetching = (isFetching) => ({
  type: SET_FETCHING_GROUP_TIMELINE,
  payload: {isFetching},
})

export const getGroupTimeline =
  (
    page,
    size, // paginate
    filter
  ) =>
  async (dispatch) => {
    try {
      dispatch(setFetching(true))
      const url = `/course/group_timelines?include=instructor&sort=date&paginate=${size}&page=${page}&${filter}`
      const response = await API.get(url)
      dispatch(
        getGroupTimelineSuccess({
          data: response.data.data,
          meta: response.data.meta,
        })
      )
      dispatch(setFetching(false))
    } catch (error) {
      throw new Error(error.response)
    }
  }
